import { useState } from "react";

import OtpPasswordModalUI from "./OtpPasswordModal.ui.tsx";
import { UseOtpPasswordModalProps, ExternalProps } from "./OtpPasswordModal.types.tsx";

import { authResendVerificationCode, authValidateCode } from "../../services/auth.services.tsx";

import { toast } from "react-toastify";

export const useOtpPasswordModal = ({
  userUuid,
  email,
  onOtpPassword,
}: ExternalProps): UseOtpPasswordModalProps => {
  const [show, setShow] = useState(false);
  const [otp, setOtp] = useState("");
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const open = async () => {
    setShow(true);
    await authResendVerificationCode();
    toast.success("Verification code sent successfully.");
  };

  const close = () => {
    setShow(false);
    setOtp("");
    setValidated(false);
  };

  const onResendCode = async () => {
    try {
      setIsLoading(true);
      await authResendVerificationCode();
      toast.success("Verification code resent successfully.");
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "API Error";
      toast.error(`Error: ${message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      setValidated(true);

      if (otp.length < 6) return;

      setIsLoading(true);
      const token = await authValidateCode(userUuid, otp);

      if (token) {
        onOtpPassword(token);
        close();
        toast.success("Verification code validated successfully");
      }
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : "API Error";
      toast.error(`Error: ${message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const modal = (
    <OtpPasswordModalUI
      show={show}
      handleClose={close}
      otp={otp}
      email={email}
      validated={validated}
      isLoading={isLoading}
      onChangeOtp={setOtp}
      onSubmit={handleSubmit}
      onResendCode={onResendCode}
    />
  );

  return { open, modal };
};
